import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { validationmethod } from "src/app/shared/common/validationmethod";

import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { constants } from "src/app/shared/common/contants";
import { CommonService } from "src/app/shared/services/common.service";
import * as moment from "moment";
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { CommonTs } from 'src/app/shared/common/CommonTs';

export interface FormData {
  ngModelObjectDivision: any;
  ngModelObject: any;
  tableName: any;
  dynamicData: any;
  retrieveObject: any;
  buttonName: any;
  listObjectDropDown: any;
  bootstrapColumn: any;
  tableID: any;
  update: any;
  headerNameHtml: any;
}

@Component({
    selector: 'app-base-popup',
    templateUrl: './base-popup.component.html',
    styleUrls: ['./base-popup.component.scss'],
    standalone: false
})
export class BasePopupComponent implements OnInit {

  formValid: UntypedFormGroup;

  headerNameHtml

  ngModelObjectDivision = [];

  ngModelObject = [];

  tableName = "";

  dynamicData = [];

  retrieveObject: any = [];

  buttonName;

  buttonNameClose;

  parentScreen = false;

  childScreen = true;

  hide = false;

  eyeIcon = true;

  listObjectDropDown: any = [];

  listObjectDropDownDuplicate: any = [];

  bootstrapColumn = 0;

  allocateButtonsBoolean = false;

  allocateButtons1Boolean = false;

  closeIconButtonBoolean = false;

  closeIconButton1Boolean = false;

  tableID = "";

  numberOfChildrenDropDowns = 0;

  childrenDropDownsIncrement = 0;

  formValidCheckbox: UntypedFormGroup;

  isCheckboxSelected: boolean = false;

  constructor(private dialogref: MatDialogRef<BasePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormData,
    private validation: validationmethod,
    private commonTs: CommonTs,
    private constants: constants,
    private service: CommonService,
    private sanitizer: DomSanitizer,
    private localStorageSettings: LocalStorageSettingsService,
    private auth: LoginService) {

  }

  ngOnInit() {

    this.formValidationsCheckbox();

    console.log(this.data);

    this.ngModelObjectDivision = this.data.ngModelObjectDivision;

    this.ngModelObject = this.data.ngModelObject;

    this.headerNameHtml = this.data.headerNameHtml;

    this.tableName = this.data.tableName;

    if (this.data.update == "true") {
      this.parentScreen = true;

      this.childScreen = false;
    }

    this.dynamicData = this.data.dynamicData;

    this.retrieveObject = this.data.retrieveObject;

    this.buttonName = this.data.buttonName;

    console.log(this.buttonName);

    this.listObjectDropDown = this.data.listObjectDropDown;

    this.data.listObjectDropDown.forEach(listObjectDropDownTemp => {

      let listTemporary: any = [];

      listObjectDropDownTemp.forEach(listObjectDropDownTemporary => {

        listTemporary.push(Object.assign({}, listObjectDropDownTemporary));

      });

      this.listObjectDropDownDuplicate.push(listTemporary);

    });

    console.log(this.listObjectDropDown);

    let dropDownChildFieldNameArray = [];

    let keyNames = [];

    let indexArray = [];

    this.ngModelObject.forEach(ngModelObjectTemp => {

      if (ngModelObjectTemp.dropDownChildFieldName != undefined) {

        //Getting children dropdown names
        dropDownChildFieldNameArray.push(ngModelObjectTemp.dropDownChildFieldName);

      }

      //Storing keyNames 
      keyNames.push(ngModelObjectTemp.keyName);

      //Storing dropdown index
      indexArray.push(ngModelObjectTemp.dropDownIndex);

    });

    console.log(dropDownChildFieldNameArray);

    this.numberOfChildrenDropDowns = dropDownChildFieldNameArray.length;

    console.log(keyNames);

    console.log(indexArray);

    dropDownChildFieldNameArray.forEach(dropDownChildFieldNameArrayTemp => {

      //Getting index of dropDownChildFieldNameArrayTemp
      let index = keyNames.indexOf(dropDownChildFieldNameArrayTemp);

      //Getting child dropDown index
      let childDropDownIndex = indexArray[index];

      console.log(childDropDownIndex);

      //Doing empty array to listObjectDropDown at childDropDownIndex
      this.listObjectDropDown[childDropDownIndex] = [];

    });

    this.tableID = this.data.tableID;

    if (this.buttonName == "Save") {

      this.buttonNameClose = "Save";

    }

    else {

      this.buttonNameClose = "Update";

      this.hide = false;

      this.eyeIcon = false;

    }

    this.bootstrapColumn = this.data.bootstrapColumn;

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }

    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    // form validations
    this.formValidations();

  }

  formValidations() {

    this.formValid = this.commonTs.formValidations(this.dynamicData);

  }

  radiochange(e) {
    console.log(e.value)

  }

  //Insert or update data to the server.
  /*async sendData() {

    let isExecute: any = 0;

    console.log(this.ngModelObject);

    isExecute = this.commonTs.checkingCombinationColumnsUnique(this.ngModelObject, this.retrieveObject, isExecute);

    console.log(isExecute);

    //Checking buttonName value has Save.
    if (this.buttonName == this.constants.btnname) {

      let tenantIDIndex: any;

      console.log(tenantIDIndex);

      //Iterating ngModelObject object for storing value in tenantid.
      for (let i = 0; i < this.ngModelObject.length; i++) {

        //This condition will execute when keyName is equal to tenantid.
        if (this.ngModelObject[i].keyName == "tenantid") {

          console.log(this.ngModelObject[i].keyValue);

          //Storing tenantid index in tenantIDIndex.
          tenantIDIndex = i;

          console.log(tenantIDIndex);

        }

      }

      //It will execute when tenantid column is present.
      if (tenantIDIndex != undefined) {

        //Getting the username from localStorage.
        let userName = this.localStorageSettings.getSettings("AuthUsername");

        console.log(userName);

        //Getting the user record from users table using userName.
        let userObject: any = await this.service.retrieveSingleRecordService("users", "userName", userName);

        console.log(userObject);

        //Getting the tenantid from first json.
        let tenantIDValue = userObject[0].tenantid;

        console.log(tenantIDValue);

        //Storing the tenantid value in keyValue where keyName is tenantid.
        this.ngModelObject[tenantIDIndex].keyValue = tenantIDValue;

        console.log(this.ngModelObject[tenantIDIndex].keyValue);

      }

    }

    let temporaryObject: any = [];

    temporaryObject = await this.commonTs.ngModelData(this.ngModelObject);

    if (this.buttonName == this.constants.btnname) {

      // checking the form is valid or not while insert
      if (!this.formValid.valid) {

        // displaying validation messages
        this.validation.validateAllFormFields(this.formValid);

        this.validation.getvalidationmessage();

      }

      else {

        console.log(temporaryObject);

        this.passwordEncrpt(temporaryObject);

        await this.commonTs.insertData(temporaryObject, this.tableName, isExecute, this.ngModelObject, this.tableID);

      }

    }

    else {

      // checking the form is valid or not while update
      if (!this.formValid.valid) {

        // displaying validation messages
        this.validation.validateAllFormFields(this.formValid);

        this.validation.getvalidationmessage();

      }

      else {

        console.log(temporaryObject);

        this.passwordEncrpt(temporaryObject);

        await this.commonTs.updateData(temporaryObject, this.tableName, isExecute, this.ngModelObject, this.tableID);

        this.reset();

      }

    }

  }*/

  reset() {

    this.ngModelObject.forEach(inputObject => {

      inputObject.keyValue = "";

      inputObject.imageShow = false;

      inputObject.imageshow1 = false;

      inputObject.fileShow = false;

      inputObject.startDateValue = moment(null);

      inputObject.endDateValue = moment(null);

      inputObject.startDateTimeValue = moment(null);

      inputObject.endDateTimeValue = moment(null);

      inputObject.binaryFormat = false;

      inputObject.downloadIconShow = false;

    });

    console.log(this.ngModelObject);

    this.formValid.reset();

    this.formValidations();

    this.ngModelObject.forEach(inputObject => {

      if (inputObject.columnType == "valueDate" && inputObject.maximumDate != undefined) {

        inputObject.endDateValue = inputObject.maximumDate;

        console.log(inputObject.endDateValue);

      }

      if (inputObject.columnType == "valueDateTime" && inputObject.maximumDateTime != undefined) {

        inputObject.endDateTimeValue = inputObject.maximumDateTime;

        console.log(inputObject.endDateTimeValue);

      }

    });

    this.buttonName = this.constants.btnname;

    this.buttonNameClose = "Save";

    this.eyeIcon = true;

  }

  // event on input type file
  imageFunction($event, ngModelTemporary): void {

    console.log($event);

    console.log(ngModelTemporary);

    this.readThisimage($event.target, ngModelTemporary);

  }

  // to encode the selected photo
  readThisimage(inputValue: any, ngModelTemporary): void {

    console.log(inputValue);

    console.log(ngModelTemporary);

    this.commonTs.readThisImage(inputValue, ngModelTemporary, this.ngModelObject, this.formValid);

  }

  openImage(image) {

    this.commonTs.openImage(image);

  }

  //delete attachements
  deleteImage(ngModelTemporary) {

    this.commonTs.deleteImage(ngModelTemporary, this.formValid, this.ngModelObject);

  }

  close() {

    this.reset();

    console.log(this.isCheckboxSelected);

    console.log(typeof this.isCheckboxSelected);

    //It will execute if checkbox is not selected.
    if (this.isCheckboxSelected == false) {

      //It will reset checkbox form.
      this.formValidCheckbox.reset();

      //It will call checkbox formValidationCheckbox method.
      this.formValidationsCheckbox();

      this.data.listObjectDropDown = [];

      this.listObjectDropDownDuplicate.forEach(listObjectTemp => {

        this.data.listObjectDropDown.push(listObjectTemp);

      });

      console.log(this.data.listObjectDropDown);

      console.log(this.listObjectDropDownDuplicate);

      this.dialogref.close(this.data.listObjectDropDown);

    }

  }

  //Insert or update data to the server.
  async sendDataAndClose() {

    let isExecute: any = 0;
    

    isExecute = this.commonTs.checkingCombinationColumnsUnique(this.ngModelObject, this.retrieveObject, isExecute);

    console.log(isExecute);

    //Checking buttonNameClose value has Save & Close.
    if (this.buttonNameClose == "Save") {

      let tenantIDIndex: any;

      console.log(tenantIDIndex);

      //Iterating ngModelObject object for storing value in tenantid.
      for (let i = 0; i < this.ngModelObject.length; i++) {

        //This condition will execute when keyName is equal to tenantid.
        if (this.ngModelObject[i].keyName == "tenantid") {

          console.log(this.ngModelObject[i].keyValue);

          //Storing tenantid index in tenantIDIndex.
          tenantIDIndex = i;

          console.log(tenantIDIndex);

        }

      }

      //It will execute when tenantid column is present.
      if (tenantIDIndex != undefined) {

        //Getting the username from localStorage.
        let userName = this.localStorageSettings.getSettings("AuthUsername");

        console.log(userName);

        //Getting the user record from users table using userName.
        let userObject: any = await this.service.retrieveSingleRecordService("users", "userName", userName);

        console.log(userObject);

        //Getting the tenantid from first json.
        let tenantIDValue = userObject[0].tenantid;

        console.log(tenantIDValue);

        //Storing the tenantid value in keyValue where keyName is tenantid.
        this.ngModelObject[tenantIDIndex].keyValue = tenantIDValue;

        console.log(this.ngModelObject[tenantIDIndex].keyValue);

      }

    }

    let temporaryObject: any = [];

    temporaryObject = await this.commonTs.ngModelData(this.ngModelObject);

    if (this.buttonNameClose == "Save") {

      // checking the form is valid or not while insert
      if (!this.formValid.valid) {

        // displaying validation messages

        this.validation.validateAllFormFields(this.formValid);

        this.validation.getvalidationmessage();

      }

      else {

        this.passwordEncrpt(temporaryObject);

        //It will generate response, it has value true or false.
        let response = await this.commonTs.insertData(temporaryObject, this.tableName, isExecute, this.ngModelObject, this.tableID);

        //Printing the response.
        console.log(response);

        //It will execute when response has value false. It means record is inserted successfully.
        if (response == false) {

          this.close();

        }

      }

    }

    else {

      // checking the form is valid or not while update
      if (!this.formValid.valid) {

        // displaying validation messages
        this.validation.validateAllFormFields(this.formValid);

        this.validation.getvalidationmessage();

      }

      else {

        this.passwordEncrpt(temporaryObject);

        //It will generate response, it has value true or false.
        let response = await this.commonTs.updateData(temporaryObject, this.tableName, isExecute, this.ngModelObject, this.tableID);

        //Printing the response.
        console.log(response);

        //It will execute when response has value false. It means record is updated successfully.
        if (response == false) {

          this.close();

        }

      }

    }

  }

  changeStartEndDateValue(ngModelTemporary) {

    this.commonTs.changeStartEndDateValue(ngModelTemporary, this.ngModelObject);

  }

  changeStartEndDateTimeValue(ngModelTemporary) {

    this.commonTs.changeStartEndDateTimeValue(ngModelTemporary, this.ngModelObject);

  }

  docdownload(ngModelTemporary) {

    console.log(ngModelTemporary);

    let imageName = "";

    this.ngModelObject.forEach(inputObject => {

      if (inputObject.keyName == ngModelTemporary.imageName) {

        imageName = inputObject.keyValue;

      }

    });

    console.log(imageName);

    this.service.download_test(ngModelTemporary.keyValue)
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        console.log(data);

        var link = document.createElement('a');
        link.href = data;
        link.download = imageName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
  }

  cancel() {

    this.reset();

    this.dialogref.close();

  }

  childDropDown(ngModelTemporary) {

    console.log(ngModelTemporary);

    if (ngModelTemporary.dropDownChildFieldName != undefined && ngModelTemporary.keyValue != "" && ngModelTemporary.keyValue != undefined) {

      console.log(ngModelTemporary);

      let dropDownChildFieldName = ngModelTemporary.dropDownChildFieldName;

      let keyName = ngModelTemporary.keyName;

      let keyValue = ngModelTemporary.keyValue;

      let childDropDownIndex: any = 0;

      this.ngModelObject.forEach(ngModelObjectTemp => {

        console.log(ngModelObjectTemp);

        if (dropDownChildFieldName == ngModelObjectTemp.keyName) {

          console.log(dropDownChildFieldName);

          console.log(ngModelObjectTemp.keyName);

          childDropDownIndex = ngModelObjectTemp.dropDownIndex;

          //When the popup is open ngmodelchange function will execute for that to stop keyValue empty
          if (this.buttonName == "Update" && this.childrenDropDownsIncrement < this.numberOfChildrenDropDowns) {

            this.childrenDropDownsIncrement++;

            console.log(this.childrenDropDownsIncrement);

          }

          else {

            ngModelObjectTemp.keyValue = "";

          }
        }

      });

      console.log(childDropDownIndex);

      console.log(this.listObjectDropDownDuplicate);

      let temporaryArray: any = [];

      this.listObjectDropDownDuplicate[childDropDownIndex].forEach(listObjectTemp => {

        if (listObjectTemp[keyName] == keyValue) {

          temporaryArray.push(listObjectTemp);

        }

      });

      this.listObjectDropDown[childDropDownIndex] = temporaryArray;

      console.log(this.listObjectDropDown);

    }

    console.log(this.listObjectDropDown);

  }

  getSanitizer(keyValue) {

    return this.sanitizer.bypassSecurityTrustUrl(keyValue);

  }

  passwordEncrpt(temporaryObject) {

    console.log("temporaryObject");

    console.log(temporaryObject);

    temporaryObject.forEach(temporaryObjectTemp => {

      if (temporaryObjectTemp.columnType == "valuePassword") {

        if ((temporaryObjectTemp.keyValue != undefined) && (temporaryObjectTemp.keyValue != null)) {

          if (temporaryObjectTemp.keyValue.toString() != "") {

            console.log(temporaryObjectTemp.columnType);

            temporaryObjectTemp.keyValue = btoa(temporaryObjectTemp.keyValue);

            temporaryObjectTemp.keyValue =  temporaryObjectTemp.keyValue;

          }

        }

      }

    });

  }

  formValidationsCheckbox() {

    // form validations
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl("")
    });

  }

}